import { render, staticRenderFns } from "./btn-edit-profile.vue?vue&type=template&id=2a9d661c&"
import script from "./btn-edit-profile.vue?vue&type=script&lang=js&"
export * from "./btn-edit-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports